import(/* webpackMode: "eager" */ "/workspace/src/app/(top)/page.tsx");
